module.exports = __webpack_public_path__ + "img/banner-contacto.553cf07b.png";